import { useWatch } from 'react-hook-form';
import { Dropdown } from '@monash/portal-react';
import { useStoreValue } from '@longsien/react-store';
import { categoriesStore } from '../../../../../shared/stores';

const getSubcategoryDropdownOptions = (categories, parentCategoryId) => {
  if (!categories || !parentCategoryId) return [];

  const parentCategory = categories.find(
    (category) => category.id === parentCategoryId
  );

  if (!parentCategory) {
    console.warn(`Category with id ${parentCategoryId} not found`);
    return [];
  }

  return parentCategory.subcategories.map((subcat) => {
    const { title, id } = subcat;
    return { text: title, value: id };
  });
};

// A wrapper for dropdown which supplies sub category options that have not already been selected.
// The logic is encapsulated here in its own component to limit re-renders.
const SubcategoriesDropdown = ({
  categoryIndex,
  subcategoryIndex,
  ...dropdownProps
}) => {
  const watchedCategory = useWatch({
    name: `categories.${categoryIndex}`,
  });

  const watchedSubcategories = useWatch({
    name: `categories.${categoryIndex}.subcategories`,
  });

  const categories = useStoreValue(categoriesStore);

  const dropdownOptions = getSubcategoryDropdownOptions(
    categories,
    watchedCategory.id
  );

  const availableSubcategoryOptions = dropdownOptions.filter((subcategory) => {
    // include the currently selected sub category as an option
    if (subcategory.value === watchedSubcategories[subcategoryIndex].id)
      return true;

    // else, only include sub categories that haven't already been selected in another dropdown
    return !watchedSubcategories.some((selectedSubcategoryObj) => {
      return subcategory.value === selectedSubcategoryObj.id;
    });
  });

  return <Dropdown data={availableSubcategoryOptions} {...dropdownProps} />;
};

export default SubcategoriesDropdown;
